import { render, staticRenderFns } from "./IconThumbsDown.vue?vue&type=template&id=27d1afe5&"
import script from "./IconThumbsDown.vue?vue&type=script&lang=js&"
export * from "./IconThumbsDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27d1afe5')) {
      api.createRecord('27d1afe5', component.options)
    } else {
      api.reload('27d1afe5', component.options)
    }
    module.hot.accept("./IconThumbsDown.vue?vue&type=template&id=27d1afe5&", function () {
      api.rerender('27d1afe5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconThumbsDown.vue"
export default component.exports